// @ts-nocheck
// ═══════════════════════════════════════════════════════════════════════════
//  PriceBreakdownPopup — ΤΟ ΚΟΙΝΟ POP-UP «ΤΙ ΠΕΡΙΛΑΜΒΑΝΕΙ»
//  ---------------------------------------------------------------------------
//  Ο χρήστης ΠΑΤΑΕΙ πάνω στην τιμή και ανοίγει μικρή κάρτα με τα περιεχόμενα.
//  ΟΧΙ browser tooltip (title="…"): πραγματικό pop-up, με θέση δίπλα στην τιμή.
//
//  ΜΙΑ υλοποίηση, δύο κοινά:
//    · Φόρμα σκάφους (υπάλληλος)      → editable: προσθήκη/διαγραφή γραμμών
//    · Επισκόπηση καρτέλας ναύλου     → read-only
//    · Παράθυρο συνδέσμου πληρωμής    → read-only
//    · Σελίδα /pay του πελάτη         → read-only
//    · (μελλοντικό «Οικονομικά» πελάτη → ίδιο component, καμία δεύτερη υλοποίηση)
//
//  Στυλ: μόνο tokens.css. Ποσά με formatMoneyEU (1.234,56 €).
// ═══════════════════════════════════════════════════════════════════════════
import React, { useEffect, useRef, useState } from 'react';
import { formatMoneyEU } from '../utils/format';

type Props = {
  /** Τίτλος της κάρτας — π.χ. «Charter pack», «Outboard». */
  title: string;
  /** Η τιμή σε ΛΕΠΤΑ. Αν λείπει, δείχνεται μόνο ο τίτλος. */
  priceCents?: number | null;
  /** Οι γραμμές «τι περιλαμβάνει». */
  lines: string[];
  /** true → ο υπάλληλος μπορεί να αλλάξει τις γραμμές. */
  editable?: boolean;
  onChange?: (lines: string[]) => void;
  /** Κείμενο όταν δεν έχει οριστεί ανάλυση. */
  emptyText?: string;
  /** Η ανάλυση της τιμής — π.χ. «100,00 € × 7 ημέρες». Δείχνεται πάνω από τις
      γραμμές, ώστε να φαίνεται ΓΙΑΤΙ βγαίνει αυτό το ποσό. Δεν είναι
      περιεχόμενο του extra: δεν αποθηκεύεται, υπολογίζεται ανά ναύλο. */
  note?: React.ReactNode;
  /** Ετικέτα κουμπιού· default = η τιμή. */
  label?: React.ReactNode;
  className?: string;
};

export default function PriceBreakdownPopup({
  title, priceCents, lines, editable = false, onChange,
  emptyText = 'Δεν έχει οριστεί ανάλυση.', note, label, className,
}: Props) {
  const [open, setOpen] = useState(false);
  const [draft, setDraft] = useState('');
  const boxRef = useRef<HTMLDivElement>(null);

  // Κλείσιμο με κλικ έξω ή Escape — συμπεριφορά pop-up, όχι modal.
  useEffect(() => {
    if (!open) return;
    const onDoc = (e: any) => { if (boxRef.current && !boxRef.current.contains(e.target)) setOpen(false); };
    const onKey = (e: any) => { if (e.key === 'Escape') setOpen(false); };
    document.addEventListener('mousedown', onDoc);
    document.addEventListener('keydown', onKey);
    return () => { document.removeEventListener('mousedown', onDoc); document.removeEventListener('keydown', onKey); };
  }, [open]);

  const add = () => {
    const v = draft.trim();
    if (!v) return;
    onChange?.([...(lines || []), v]);
    setDraft('');
  };
  const remove = (i: number) => onChange?.((lines || []).filter((_, j) => j !== i));

  const priceText = (priceCents === null || priceCents === undefined)
    ? null : formatMoneyEU(priceCents / 100);

  return (
    <span ref={boxRef} className={className} style={{ position: 'relative', display: 'inline-block' }}>
      <button type="button" className="yms-btn yms-price"
              aria-expanded={open} aria-haspopup="dialog"
              onClick={() => setOpen(o => !o)}
              title="Τι περιλαμβάνει">
        {label ?? priceText ?? title}
        <span className="yms-price-i" aria-hidden="true">i</span>
      </button>

      {open && (
        <div className="yms-pop" role="dialog" aria-label={title}>
          <div className="yms-pop-h">
            <b>{title}</b>
            {priceText && <span className="yms-mono">{priceText}</span>}
          </div>

          {note && <div className="yms-hint" style={{ marginBottom: 6 }}>{note}</div>}

          {(lines || []).length === 0 ? (
            <div className="yms-mempty" style={{ padding: '8px 0' }}>{emptyText}</div>
          ) : (
            <ul className="yms-pop-list">
              {lines.map((l, i) => (
                <li key={i}>
                  <span>{l}</span>
                  {editable && (
                    <button type="button" className="yms-btn yms-btn-danger"
                            style={{ padding: '1px 6px', fontSize: 11 }}
                            onClick={() => remove(i)} title="Αφαίρεση">×</button>
                  )}
                </li>
              ))}
            </ul>
          )}

          {editable && (
            <div className="yms-toolbar" style={{ marginTop: 8, gap: 6 }}>
              <input className="yms-in" value={draft} placeholder="Προσθήκη γραμμής…"
                     onChange={e => setDraft(e.target.value)}
                     onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); add(); } }} />
              <button type="button" className="yms-btn yms-btn-primary" onClick={add}>+</button>
            </div>
          )}
        </div>
      )}
    </span>
  );
}
